/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import CurrentPageContext from '../../../../../contexts/CurrentPageContext';
import AvailableUnitsCount from '../../themes/AvailableUnitsCount';
import styles from './SizeWithUnitDetails.scss';

export default class SizeWithUnitDetails extends React.Component {
  static propTypes = {
    size: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    amenities: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      token: PropTypes.string,
    })).isRequired,
    maxItems: PropTypes.number,
  };

  static defaultProps = {
    maxItems: 5,
  };

  static contextType = CurrentPageContext;

  state = {
    expanded: false,
  };

  toggleAmenities = () => {
    const { expanded } = this.state;

    if (expanded) {
      this.setState({ expanded: false });
    } else {
      this.setState({ expanded: true });
    }
  }

  renderAmenities() {
    const { secondaryColorClass } = this.context;
    const { type, amenities, maxItems } = this.props;
    const { expanded } = this.state;
    const amenityNames = amenities.map(amenity => amenity.name);
    const features = [
      type,
      ...amenityNames,
    ];

    if (amenities.length > maxItems) {
      let limitedFeatures;
      if (expanded) {
        limitedFeatures = features;
      } else {
        limitedFeatures = features.slice(0, maxItems);
      }

      return (
        <div>
          <div>
            {limitedFeatures.join(', ')}
          </div>
          <div
            onClick={this.toggleAmenities}
            className={`${styles.contentToggle} ${secondaryColorClass}`}
          >
            View {expanded ? 'Less' : 'More Amenities'}
          </div>
        </div>
      );
    }
    return (
      <div>
        {features.join(', ')}
      </div>
    );
  }


  render() {
    const { size } = this.props;

    return (
      <div>
        <div className={styles.size} data-testid="unitSize">
          {size}
          <span className={styles.unitsCount}>
            <AvailableUnitsCount {...this.props} />
          </span>
        </div>
        <div className={styles.unitDetails}>
          {this.renderAmenities()}
        </div>
      </div>
    );
  }
}
